module.exports = __webpack_public_path__ + "img/profess1.736d4cd4.png";